import { createFileRoute } from "@tanstack/react-router";
import { DayBeforeInstructions } from "@/components/site/DayBeforeInstructions";

export const Route = createFileRoute("/daybefore_sms")({
  head: () => ({
    meta: [
      { title: "SMS – Day Before - Restore Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair pre-operative reminders for the day before your FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Pre-Procedure Reminders | RESTORE® Hair" },
      {
        property: "og:description",
        content: "What to do — and what to avoid — the day before your RESTORE® Hair FUE procedure.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/daybefore_sms/" }],
  }),
  component: () => <DayBeforeInstructions />,
});
